import { useSearchParams } from 'next/navigation'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { TENANT } from '../../../tenant/tenantTypes'

export const useRemovePackagesForExpaExperimentIsExpaPresentInUrl =
  (): boolean => {
    const searchParams = useSearchParams()
    const { tenant } = useGlobalConfigContext()
    const expaValue = searchParams.get('expa')

    const getExpasToDisplaySingleVariant = (): string[] => {
      switch (tenant) {
        case TENANT.CH: {
          return [
            'shof',
            'pre',
            'ads',
            'kel',
            'bil',
            'shop',
            'com',
            'gue',
            'doo',
            'de1',
            'de2',
            'de3',
            'gglp',
            'ovtp',
          ]
        }
        case TENANT.COM: {
          return [
            'gglp',
            'gue',
            'bil',
            'gei',
            's24',
            'con',
            'kel',
            'twe',
            'pre',
            'shom',
            'sho',
            'ads',
            'doo',
            'shof',
            'sty',
            'def2',
            'def3',
            'ovtp',
            'eba',
            'shp',
            'mev',
            'tes',
            'def1',
            'ide',
            'c24',
            'lad',
            'spa',
            'apo',
            'medi',
            'arz',
            'med',
          ]
        }
        default: {
          return []
        }
      }
    }

    const expasToDisplaySingleVariant = getExpasToDisplaySingleVariant()

    return expaValue !== null && expasToDisplaySingleVariant.includes(expaValue)
  }
